module.exports = __webpack_public_path__ + "static/media/link_grey.c7fcba7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/link_grey.svg
// module id = 185
// module chunks = 0